'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetPopupContainer = function (_React$Component) {
  (0, _inherits3.default)(AssetPopupContainer, _React$Component);

  function AssetPopupContainer(props) {
    (0, _classCallCheck3.default)(this, AssetPopupContainer);
    return (0, _possibleConstructorReturn3.default)(this, (AssetPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(AssetPopupContainer)).call(this, props));
  }

  (0, _createClass3.default)(AssetPopupContainer, [{
    key: 'render',
    value: function render() {
      var styles = require('./AssetPopupNav.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.AssetPopupNav__container },
        _react2.default.createElement(
          'div',
          { className: styles.AssetPopupNav },
          _react2.default.createElement(_components.Button, { primary: true, label: 'Megascans Home', link: true, to: '/' }),
          _react2.default.createElement(_components.Button, { label: 'View the Full Library', link: true, to: '/types/everything' })
        )
      );
    }
  }]);
  return AssetPopupContainer;
}(_react2.default.Component);

exports.default = AssetPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetPopupNav/AssetPopupNav.jsx
// module id = 2452
// module chunks = 0